<template>
  <el-row class="new-editor-wrap" :class="getThemeInfo" v-loading="getLoadingInfo" v-if="isMno">
    <el-col :span="24" class="top-area">
      <EditorTop />
    </el-col>
    <el-col :span="24" class="operation-area">
      <EditorOperation :editorMode="editorMode" @setEditorMode="setEditorMode" @setLeftColumnName="setLeftColumnName"
        @setUpdataFragmentType="setUpdataFragmentType" />
    </el-col>
    <el-col :span="24" class="main-area">
      <EditorArea :editorMode="editorMode" @setCurrentId="setCurrentId" />
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Mixin from "./modules/mixin";
import EditorTop from "./modules/editorTop";
import EditorArea from "./modules/editorArea";
import EditorOperation from "./modules/editorOperation";
import { setTimeout } from "timers";
import { debounce } from "@/components/editor/common";

import Vue from "vue";
const v = new Vue();

export default {
  name: "NewEditor",
  beforeRouteEnter(to, from, next) {
    // 接收作业模式的
    let { companyCode, transModel } = JSON.parse(v.$Base64.decode(to.query.key));
    companyCode && sessionStorage.setItem('companyCode', companyCode);
    typeof transModel === 'number' && sessionStorage.setItem('transModel', transModel);
    next();
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem('companyCode');
    const transModel = sessionStorage.getItem('transModel')
    if (transModel !== undefined && transModel !== null) {
      sessionStorage.removeItem('transModel');
    }
    next();
  },
  mixins: [Mixin],
  data() {
    return {
      querydata: {},
      options: [{
        value: 'source',
        label: '原文',
      }, {
        value: 'translate',
        label: '翻译',
        children: [{
          value: 'target-1',
          label: '翻译:译文'
        }, {
          value: 'source-target-2',
          label: '翻译:原译对照'
        }]
      }, {
        value: 'proofread',
        label: '审校',
        children: [{
          value: 'target-3',
          label: '审校:译文'
        }, {
          value: 'source-target-4',
          label: '审校:原译对照'
        }]
      }, {
        value: 'lastProofread',
        label: '复审',
        children: [{
          value: 'target-5',
          label: '复审:译文'
        }, {
          value: 'source-target-6',
          label: '复审:原译对照'
        }]
      }, {
        value: 'editorMark',
        label: '修订痕迹',
      }, {
        value: 'XLF',
        label: 'XLF文档',
      }, {
        value: 'TMX',
        label: 'TMX文档',
      }, {
        value: 'QA',
        label: 'QA报告',
      }]
    };
  },
  components: { EditorTop, EditorOperation, EditorArea },
  computed: {
    ...mapGetters('editor', [
      'getThemeInfo',                // 主题信息
      'getUrlInfo',                  // 获取路由信息
      'getTaskContentListParams',    // 列表接口基础参数
    ]),
    ...mapGetters({
      getLoadingInfo: 'editor/getLoading',  // 获取加载信息
    }),
    isMno() {
      const { sourceLang, targetLang } = this.getUrlInfo
      if ([sourceLang, targetLang].includes('mno')) {
        return false
      }
      return true
    }
  },
  created() {
    // 将路由信息 存储vuex
    const queryInfo = JSON.parse(this.$Base64.decode(this.$route.query.key)) || {};
    this.$store.dispatch('editor/setUrlInfo', queryInfo)
    this.setThemeInfoForStrorage()
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener("unload", (e) => this.unload(e));
    })
    const theme = [{ value: 'standard', label: '普通模式' }, { value: 'dark', label: '夜间模式', }, { value: 'eye-protection', label: '护眼模式' }]
    this.$store.dispatch('editor/updateTheme', theme)
    const self = this;
    self.getProjectInfo();
    self.setEditorMode('standard');
    //获取-文件信息
    let options = [];
    //进入方式判断 - 项目/任务/作业模式
    const { type, fileId, taskId, taskType, sourceLang, targetLang } = this.getUrlInfo
    if (type === 'project') {
      console.log('项目进入project');
      // 文件信息
      self.getFileInfo();
      //文件内容
      self.getFileContent();
      //获取-任务信息
    } else if (type === 'task') {
      console.log('任务进入task');
      let preParams = Object();
      let preParams2 = Object();
      Reflect.set(preParams, 'id', fileId);
      Reflect.set(preParams, 'fileId', fileId);
      Reflect.set(preParams, 'taskId', taskId);
      Reflect.set(preParams, 'taskType', taskType);
      Reflect.set(preParams2, 'id', taskId);
      //任务信息-任务进度-任务内容
      Promise.all([self.$store.dispatch('editor/getFileTaskInfo', preParams2), self.$store.dispatch('editor/getTaskProgress', preParams)]).then((resp) => {
        if (parseInt(resp.length) === 2) {
          let firstItem = resp[0];
          let lastItem = resp[1];
          firstItem.progress = (lastItem.progress);
          self.$store.dispatch('editor/setFileTaskSupplyInfo', firstItem)
        }
      }).then(() => {
        this.getTaskContent()
      });
      let sourceItem = {
        value: 'source',
        label: '原文',
      };
      options.push(sourceItem);
      //任务进入判断任务类型
      let translateItem = {}
      let proofreadItem = {}
      let lastProofreadItem = {}
      switch (parseInt(taskType)) {
        case 1:
          translateItem = {
            value: 'translate',
            label: '翻译',
            children: [{
              value: 'target-1',
              label: '翻译:译文'
            }, {
              value: 'source-target-2',
              label: '翻译:原译对照'
            }]
          };
          options.push(translateItem);
          console.log('翻译');
          break;
        case 2:
          proofreadItem = {
            value: 'proofread',
            label: '审校',
            children: [{
              value: 'target-3',
              label: '审校:译文'
            }, {
              value: 'source-target-4',
              label: '审校:原译对照'
            }]
          };
          options.push(proofreadItem);
          console.log('审校');
          break;
        case 3:
          lastProofreadItem = {
            value: 'lastProofread',
            label: '复审',
            children: [{
              value: 'target-5',
              label: '复审:译文'
            }, {
              value: 'source-target-6',
              label: '复审:原译对照'
            }]
          };
          options.push(lastProofreadItem);
          console.log('复审');
          break;
        default:
          console.log('未知任务');
          break;
      }
      let TMXItems = {
        value: 'TMX',
        label: 'TMX文档',
      };
      options.push(TMXItems);
      this.options = options;

    } else if (type === 'school') {
      console.log('学校进入school');
      let preParams = Object();
      let preParams2 = Object();
      Reflect.set(preParams, 'id', fileId);
      Reflect.set(preParams, 'fileId', fileId);
      Reflect.set(preParams, 'taskId', taskId);
      Reflect.set(preParams, 'taskType', taskType);
      if (this.getUrlInfo.transModel) {
        // isClassVersion 是否是班级管理版本 作业进度接口参数
        Reflect.set(preParams, 'isClassVersion', 1);
      }
      Reflect.set(preParams2, 'id', taskId);
      Promise.all([self.$store.dispatch('editor/getFileTaskInfo', preParams2), self.$store.dispatch('editor/getTaskProgress', preParams)]).then((resp) => {
        if (parseInt(resp.length) === 2) {
          let firstItem = resp[0];
          let lastItem = resp[1];
          firstItem.progress = (lastItem.progress);
          self.$store.dispatch('editor/setFileTaskSupplyInfo', firstItem)
        }
      }).then(() => {
        this.getSchoolTaskContent()
      });
    }
    this.$store.dispatch('editor/updateImportOption', this.options)
    if ([sourceLang, targetLang].includes('mno')) {
      this.$router.push({
        path: "/mongoEditor",
        query: {
          key: this.$Base64.encode(JSON.stringify(this.getUrlInfo)),
          importOption: this.$Base64.encode(JSON.stringify(this.options))
        }
      })
    }
    // webSocket 发送消息 订阅
    this.WEBSOCKET_SELECTOR({
      type: "transInput",
      selector: "fileId=" + fileId
    })
    // webSocket 发送消息 订阅
    this.WEBSOCKET_SELECTOR({
      type: "adminTransInput",
      selector: "fileId=" + fileId
    })
  },

  destroyed() {
    this.$store.commit('editor/INIT_EDITOR_STATE', {})
    this.setEditorMode('standard');
    window.removeEventListener("unload", (e) => this.unload(e));
  },

  methods: {
    ...mapActions('ws', ['WEBSOCKET_SELECTOR']),
    unload(e) {
      // localStorage.setItem('theme', 'standard')
      // this.$store.dispatch('editor/setThemeInfo', 'standard')
    },
    setThemeInfoForStrorage(){
      let themeInfo = localStorage.getItem('theme')
      this.$store.dispatch('editor/setThemeInfo', themeInfo)
    },
    //获取项目信息
    getProjectInfo() {
      let params = Object();
      const { projectId } = this.getUrlInfo
      Reflect.set(params, 'id', projectId);
      this.$store.dispatch('editor/projectInfo', params).then((resp) => {
        if (resp && !!(resp.projectProcessType)) {
          let options = this.options;
          let projectProcessType = parseInt(resp.projectProcessType);
          switch (projectProcessType) {
            case 1:
              options.forEach((item, index) => {
                if (((item.value) === 'proofread') || ((item.value) === 'lastProofread')) {
                  options.splice(index, 2);
                }
              });
              break;
            case 2:
              options.forEach((item, index) => {
                if (((item.value) === 'lastProofread')) {
                  options.splice(index, 1);
                }
              });
              break;
            case 3:
              break;
            default:
              break;
          }
        }
      });
    },

    //获取文件
    getFileInfo() {
      let params = Object();
      const { fileId } = this.getUrlInfo
      Reflect.set(params, 'id', fileId);
      this.$store.dispatch('editor/getFileInfo', params)
    },

    //获取文件内容
    getFileContent() {
      const { type, fileId, taskType } = this.getUrlInfo
      const marker = type === 'project' ? 2 : 1
      const params = {
        ...this.getTaskContentListParams,
        marker,
        comparedHighlight: 0,
        showTerm: 1,
        transFileId: fileId,
        taskType: taskType || 1
      }
      Reflect.deleteProperty(params, 'taskId')
      this.$store.dispatch('editor/getFileContent', params)
    },

    //获取任务信息
    getTaskContent() {
      const { type, fileId, taskType, taskId } = this.getUrlInfo
      const marker = type === 'project' ? 2 : 1
      const params = {
        ...this.getTaskContentListParams,
        marker,
        comparedHighlight: 0,
        showTerm: 1,
        transFileId: fileId,
        taskType: taskType || 1,
        taskId,
        // transModel: 0
      }
      this.$store.dispatch('editor/getTaskContent', params)
    },

    //获取高校模式下的编辑器内容
    getSchoolTaskContent() {
      const { type, fileId, taskId, taskType } = this.getUrlInfo
      const marker = type === 'project' ? 2 : 1
      const params = {
        ...this.getTaskContentListParams,
        marker,
        comparedHighlight: 0,
        showTerm: 1,
        transFileId: fileId,
        taskId,
        taskType: taskType || 1,
        // transModel: 1
      }
      this.$store.dispatch('editor/getTaskContent', params)
    },

    // //获取任务进度
    // getTaskProgress (data) {
    //   let params = Object();
    //   Reflect.set(params, 'fileId', data.fileId);
    //   return this.$store.dispatch('editor/getTaskProgress', params)
    // },
  },
}
</script>

<style lang="less" scoped>
@import "assets/new-editor.less";
</style>
